/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Bonisoft Backend API
 * Bonisoft Backend API
 * OpenAPI spec version: 1
 */

export type RewardCalculationType = typeof RewardCalculationType[keyof typeof RewardCalculationType];


export const RewardCalculationType = {
  DefinedBySubtypeCalculationType: 'DefinedBySubtypeCalculationType',
  ManualInputCalculationType: 'ManualInputCalculationType',
  MaxPointsCalculationType: 'MaxPointsCalculationType',
  PercentMaxPointsCalculationType: 'PercentMaxPointsCalculationType',
  SplitMaxPointsCalculationType: 'SplitMaxPointsCalculationType',
  ScoreRangeCalculationType: 'ScoreRangeCalculationType',
  FixedRewardCalculationType: 'FixedRewardCalculationType',
  ScoreMultiplyRewardCalculationType: 'ScoreMultiplyRewardCalculationType',
} as const;
